import {AppContext} from "../context/AppProvider";
import {useContext} from "react";

function useCan(permission) {
	const {permissions} = useContext(AppContext);
	// 'root' (siêu quản trị) có toàn bộ quyền
	if (permissions && permissions.root) return true;
	return typeof permissions !== 'undefined' && typeof permissions[permission] !== 'undefined' && permissions[permission] === true;
}

export default useCan;